import { 
  Accordion, 
  AccordionDetails, 
  AccordionSummary, 
  Typography,
  Card 
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { memo } from 'react'
import { useThemeMode } from "hooks/useThemeMode";
import { accordionStyles } from './styles'
import Delete from '@mui/icons-material/Delete';
import RegularButton from 'components/CustomButtons/Button';
import { FormContractRuleEdit } from './FormContractRuleEdit';

export const ContractRuleAccordion = memo((props) => {
  const { rule, rules, rulesKeys, setRules, setRulesKeys } = props
  const { isDark } = useThemeMode();
  const classes = accordionStyles({ isDark });

  return (
    <>
      <Card className={`${classes.border} `} sx={{width: '100%', boxShadow: 3}}>                  
        <Accordion style={{backgroundColor: 'rgba(238, 238, 238 ,1)'}}>
          <AccordionSummary
            expandIcon={ <ExpandMoreIcon className={classes.icon} /> }
            className={ `${classes.box}} ${classes[rule.isComplete]}` }
          >
            <Typography style={{alignSelf: 'center'}} className={classes.heading}>{rule.name}</Typography>
            <RegularButton 
              round 
              justIcon 
              color={"danger"} 
              style={{ margin: 0 }} 
              onClick={(e) => {
                e.stopPropagation()
                setRules(rules.filter(item => item.itemId !== rule.itemId))
                setRulesKeys(rulesKeys.filter(item => item.idRule !== rule.id))
              }}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
          </AccordionSummary>
          <AccordionDetails>
            <FormContractRuleEdit ruleHandlers={props} />
          </AccordionDetails>
        </Accordion>
      </Card>
    </>
  )
})
